import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { LoginModel } from '../models/login.model';

@Injectable({
  providedIn: 'root'
})
export class LoginRepository {

  private apiUrl: string = environment.apiUrl;

  constructor(
    private httpClient: HttpClient
  ) { }

  public loginCostumer(loginForm: LoginModel): Observable<LoginModel> {
    let headers = new HttpHeaders();
    headers = headers.set('token-recaptcha', loginForm.token);
    return this.httpClient.post<any>(`${this.apiUrl}/customer/login`, loginForm, {headers: headers});
  }

  public loginProducer(loginForm: LoginModel): Observable<LoginModel> {
    let headers = new HttpHeaders();
    headers = headers.set('token-recaptcha', loginForm.token);
    headers = headers.set('x-login-producer','')
    return this.httpClient.post<any>(`${this.apiUrl}/user/login`, loginForm, {headers: headers});
  }

}
